export type StateType = {
  token?: string;
};

export type ActionType = {
  type: string;
  token: string;
};

export const globalReducer = (state: StateType, action: ActionType) => {
  switch (action.type) {
    case 'setToken':
      return { ...state, token: action.token };
    default:
      return state;
  }
};
